import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ValAddInventoryDto } from './val-addtion-inventory.dto';

export class ValAdditionResponseModel extends GlobalResponseObject{
    data?: ValAddInventoryDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ValAddInventoryDto){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }

}
